import { apiInstance } from "api/config/axios";
import { getApiResponseData } from "./api-service";
import { IApiResponse } from "api/models/IApiResponse";
import { IAddWorkspaceRequest } from "api/models/request/IAddWorkspaceRequest";
import { IEditWorkspaceRequest } from "api/models/request/IEditWorkspaceRequest";
import { ISwitchWorkspaceRequest } from "api/models/request/ISwitchWorkspaceRequest";
import { ICreateTrainingFeedbackRequest } from "api/models/request/feedback/ICreateTrainingFeedbackRequest";
import { IUpdateTrainingFeedbackRequest } from "api/models/request/feedback/IUpdateTrainingFeedbackRequest";
import { ITrainingFeedbackModel } from "api/models/response/feedback/ITrainingFeedbackModel";

const workspaceApiBaseUrl = '/workspace';

export const getCurrentWorkspaceInfo = (): Promise<IApiResponse<any>> => {
    return apiInstance.get(`${workspaceApiBaseUrl}/current`).then((response) => {
        return getApiResponseData(response);
    });
}
export const addWorkspace = (request: IAddWorkspaceRequest): Promise<IApiResponse<string>> => {
    return apiInstance.post(workspaceApiBaseUrl, request).then((response) => {
        return getApiResponseData(response);
    });
};

export const editWorkspaceName = (request: IEditWorkspaceRequest & { workspaceId: string }): Promise<IApiResponse<any>> => {
    return apiInstance.patch(`${workspaceApiBaseUrl}/${request.workspaceId}/name`, { name: request.name }).then((response) => {
        return getApiResponseData(response);
    });
};

export const switchWorkspace = (request: ISwitchWorkspaceRequest & { workspaceId: string }): Promise<IApiResponse<any>> => {
    return apiInstance.patch(`${workspaceApiBaseUrl}/switch`, { workspaceId: request.workspaceId }).then((response) => {
        return getApiResponseData(response);
    });
};

export const patchWorkspaceMfa = (request: { mfaEnabled: boolean } & { workspaceId: string; }): Promise<IApiResponse<any>> => {
    return apiInstance.patch(`${workspaceApiBaseUrl}/${request.workspaceId}/mfa`, { mfaEnabled: request.mfaEnabled }).then((response) => {
        return getApiResponseData(response);
    });
}

export const deleteWorkspace = (request: { workspaceId: string }): Promise<IApiResponse<any>> => {
    return apiInstance.delete(`${workspaceApiBaseUrl}/${request.workspaceId}`).then((response) => {
        return getApiResponseData(response);
    });
};

export const getWorkspaceFeedback = (request: { workspaceId: string }): Promise<IApiResponse<ITrainingFeedbackModel[]>> => {
    return apiInstance.get(`${workspaceApiBaseUrl}/${request.workspaceId}/feedback`).then((response) => {
        return getApiResponseData(response);
    });
};

export const createWorkspaceFeedback = (
    request: { workspaceId: string } & ICreateTrainingFeedbackRequest
): Promise<IApiResponse<string>> => {
    return apiInstance.post(`${workspaceApiBaseUrl}/${request.workspaceId}/feedback`, request).then((response) => {
        return getApiResponseData(response);
    });
};

export const patchWorkspaceFeedback = (
    request: { workspaceId: string; feedbackId: string } & IUpdateTrainingFeedbackRequest
): Promise<IApiResponse<unknown>> => {
    return apiInstance.patch(`${workspaceApiBaseUrl}/${request.workspaceId}/feedback/${request.feedbackId}`, request).then((response) => {
        return getApiResponseData(response);
    });
};

export const deleteWorkspaceFeedback = (
    request: { workspaceId: string; feedbackId: string }
): Promise<IApiResponse<unknown>> => {
    return apiInstance.delete(`${workspaceApiBaseUrl}/${request.workspaceId}/feedback/${request.feedbackId}`).then((response) => {
        return getApiResponseData(response);
    });
};